var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 51,
    viewBox: "0 0 293 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.658386V4.25327L33.0148 3.95041V0.658386H0Z",
    fill: "url(#paint0_linear_24_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23.7026V27.2975L33.0148 26.9946V23.7026H0Z",
    fill: "url(#paint1_linear_24_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 47.4051V51L33.0148 50.6971V47.4051H0Z",
    fill: "url(#paint2_linear_24_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.628 0V3.59489L140.643 3.29202V0H107.628Z",
    fill: "url(#paint3_linear_24_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.628 23.0441V26.639L140.643 26.3362V23.0441H107.628Z",
    fill: "url(#paint4_linear_24_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.628 46.7467V50.3416L140.643 50.0387V46.7467H107.628Z",
    fill: "url(#paint5_linear_24_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5437 0.658386H48.7564L68.3408 45.7591L89.2986 0.658386H93.1811L70.5858 51H67.1324L44.5437 0.658386Z",
    fill: "url(#paint6_linear_24_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.225 51H159.686V0.658386H163.225L197.099 45.1007V0.658386H200.314V51H197.112L163.423 8.23004L163.225 51Z",
    fill: "url(#paint7_linear_24_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.643 0.658386H254.604V4.02942H236.479V51H232.854V3.62121H214.643V0.658386Z",
    fill: "url(#paint8_linear_24_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.774 10.8636H276.334V40.6762H279.774V10.8636Z",
    fill: "url(#paint9_linear_24_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.007 24.0515H263.108V27.4818H293.007V24.0515Z",
    fill: "url(#paint10_linear_24_16)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_16",
    x1: 0,
    y1: 2.45583,
    x2: 33.0148,
    y2: 2.45583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#821B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24_16",
    x1: 0,
    y1: 25.5,
    x2: 0.660297,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#821B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24_16",
    x1: 0,
    y1: 49.2025,
    x2: 0.660297,
    y2: 49.2025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#821B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_24_16",
    x1: 107.628,
    y1: 1.79744,
    x2: 140.643,
    y2: 1.79744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#821B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_24_16",
    x1: 107.628,
    y1: 24.8416,
    x2: 140.643,
    y2: 24.8416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#821B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_24_16",
    x1: 107.628,
    y1: 48.5441,
    x2: 140.643,
    y2: 48.5441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#821B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_24_16",
    x1: 44.5437,
    y1: 25.8292,
    x2: 93.1811,
    y2: 25.8292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#821B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_24_16",
    x1: 159.686,
    y1: 25.8292,
    x2: 200.314,
    y2: 25.8292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#821B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_24_16",
    x1: 214.643,
    y1: 25.8292,
    x2: 254.604,
    y2: 25.8292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#821B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_24_16",
    x1: 276.334,
    y1: 25.7699,
    x2: 279.774,
    y2: 25.7699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#821B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_24_16",
    x1: 263.108,
    y1: 25.77,
    x2: 293,
    y2: 25.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#821B47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 293,
    height: 51,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPink);
export default __webpack_public_path__ + "static/media/logo-pink.dd2292dc15cf68ca9a3d517a2b1fb10a.svg";
export { ForwardRef as ReactComponent };